import { useMutation } from '@tanstack/react-query';
import { deleteAlternative } from "@/api/alternative"; 
import { DeleteAlternativeRequest } from "@/types"; 
import { PostParam } from "@/types/index"; 

export function useDeleteAlternative(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<any, Error, DeleteAlternativeRequest>({
    mutationFn: deleteAlternative,
    onSuccess,
    onError
  });
}